var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 204.6 50",
    style: {
      enableBackground: "new 0 0 204.6 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25 0 0 -1.25 0 312.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E60023",
    d: "M70.7,235.6h5v-2.2h0.1c1.2,1.7,2.8,2.7,5,2.7c3.6,0,5.6-2.5,5.6-6.2v-10.6h-5.2v9.5c0,1.7-0.9,2.9-2.5,2.9 c-1.7,0-2.9-1.4-2.9-3.4v-9h-5.2V235.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E60023",
    d: "M64.5,235.6h5.2v-16.2h-5.2V235.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E60023",
    d: "M70.2,239.9c0,1.7-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1S70.2,238.2,70.2,239.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E60023",
    d: "M122.8,235.8c-0.1,0-0.3,0-0.5,0c-2,0-3.3-0.9-4.4-2.8h-0.1v2.5h-4.9v-16.2h5.2v7.3c0,3.4,1.9,4.9,4.8,4.7 V235.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E60023",
    d: "M148.2,229.6c-2.1,0.4-3.9,0.5-3.9,1.7c0,1,1,1.5,2.3,1.5c1.4,0,2.4-0.4,2.6-1.9h4.8 c-0.3,3.2-2.7,5.2-7.3,5.2c-3.8,0-7-1.8-7-5.2c0-3.8,3-4.6,5.8-5c2.2-0.4,4.1-0.5,4.1-2c0-1-1-1.6-2.5-1.6c-1.6,0-2.6,0.7-2.9,2 h-4.9c0.4-3.3,3.3-5.4,7.9-5.4c4.3,0,7.4,1.8,7.4,5.4C154.4,228.4,151,229.1,148.2,229.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E60023",
    d: "M130.8,232.4c1.7,0,2.9-1.2,3.1-3.2h-6.4C127.9,231.1,128.9,232.4,130.8,232.4 M131.1,222.6 c-2.1,0-3.3,1.4-3.6,3.6h11.7c0,3.3-0.9,6.1-2.9,7.9c-1.4,1.3-3.2,2-5.6,2c-4.9,0-8.3-3.7-8.3-8.6c0-4.9,3.3-8.6,8.7-8.6 c2.1,0,3.7,0.5,5.1,1.5c1.4,1,2.4,2.4,2.7,3.8h-5C133.4,223.2,132.5,222.6,131.1,222.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E60023",
    d: "M163.5,223.2c-0.2,0-0.6,0-0.9,0c-1.1,0-1.8,0.3-1.8,1.6v7.6h2.7v3.2h-2.7v5.1h-5v-5.1h-1.6v-3.2h1.6v-8.7 c0-3.5,2.2-4.5,5.2-4.5c1.1,0,2,0.1,2.5,0.2C163.5,219.3,163.5,223.2,163.5,223.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E60023",
    d: "M95.7,223.2c-0.2,0-0.4,0-0.7,0c-1.1,0-1.8,0.3-1.8,1.6v7.6h2.5v3.2h-2.5v5.1h-5v-5.1h-1.7v-3.2h1.7v-8.7 c0-3.5,2.2-4.5,5.2-4.5c1,0,1.8,0.1,2.3,0.2V223.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E60023",
    d: "M107,229.2c-0.2,1.9-1.4,3.2-3.1,3.2c-2,0-3-1.2-3.3-3.2H107z M95.4,227.5c0,4.9,3.4,8.6,8.3,8.6 c2.3,0,4.2-0.8,5.6-2c1.9-1.8,2.9-4.6,2.9-7.9h-11.7c0.3-2.2,1.5-3.6,3.6-3.6c1.4,0,2.3,0.6,2.7,1.6h5c-0.3-1.5-1.3-2.9-2.7-3.8 c-1.4-1-3-1.5-5.1-1.5C98.7,218.9,95.4,222.6,95.4,227.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E60023",
    d: "M55.5,231.4c2,0,3.2,1.2,3.2,3c0,1.8-1.2,2.9-3.2,2.9h-4v-5.9H55.5z M46.3,242h9c2.8,0,4.8-0.8,6.2-2.1 c1.5-1.4,2.3-3.3,2.3-5.6c0-4.3-3-7.4-7.7-7.4h-4.5v-7.6h-5.2C46.3,219.3,46.3,242,46.3,242z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E60023",
    d: "M19.7,249.5c-10.8,0-19.5-8.7-19.5-19.5c0-8.3,5.1-15.3,12.4-18.2c-0.2,1.5-0.3,3.9,0.1,5.6 c0.4,1.5,2.3,9.7,2.3,9.7s-0.6,1.2-0.6,2.9c0,2.7,1.6,4.7,3.5,4.7c1.7,0,2.5-1.3,2.5-2.7c0-1.7-1.1-4.2-1.6-6.5 c-0.5-1.9,1-3.5,2.9-3.5c3.5,0,6.1,3.7,6.1,8.9c0,4.7-3.4,7.9-8.2,7.9c-5.6,0-8.8-4.2-8.8-8.5c0-1.7,0.6-3.5,1.5-4.5 c0.2-0.2,0.2-0.4,0.1-0.6c-0.1-0.6-0.5-1.9-0.5-2.2c-0.1-0.4-0.3-0.4-0.7-0.3c-2.4,1.1-4,4.7-4,7.6c0,6.2,4.5,11.8,12.9,11.8 c6.8,0,12-4.8,12-11.3c0-6.7-4.2-12.1-10.1-12.1c-2,0-3.8,1-4.5,2.2c0,0-1-3.7-1.2-4.6c-0.4-1.7-1.6-3.8-2.4-5.1 c1.8-0.6,3.8-0.9,5.8-0.9c10.8,0,19.5,8.7,19.5,19.5C39.2,240.8,30.5,249.5,19.7,249.5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.d2479d83ecfc3f4bea78385755ed66fb.svg";
export { ForwardRef as ReactComponent };